export function getBffBaseUrl(): string {
  return requiredEnvVar(process.env.NEXT_PUBLIC_BFF_API_URL, 'NEXT_PUBLIC_BFF_API_URL')
}

function requiredEnvVar(value: string | undefined, keyName: string): string {
  if (typeof value === 'string') return value
  throw new Error(`A required env var is missing: "${keyName}"`)
}
